import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@icon/play-not-found.svg'


const _hoisted_1 = ["data-fancybox", "video-data-fancybox", "data-caption", "data-file-metadata-id", "href", "data-type"]
const _hoisted_2 = { class: "video-attachment" }
const _hoisted_3 = { class: "video-attachment__video ready-to-play" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "video-attachment__info"
}
const _hoisted_6 = {
  key: 1,
  class: "video-attachment video-attachment_deleted"
}
const _hoisted_7 = { class: "video-attachment__video" }
const _hoisted_8 = {
  key: 0,
  class: "video-attachment_deleted__name-wrapper"
}
const _hoisted_9 = { class: "video-attachment_deleted__name-wrapper" }
const _hoisted_10 = { class: "custom-file-simplified__icon" }
const _hoisted_11 = {
  key: 0,
  class: "video-attachment__info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["video-attachment-wrapper", [{ 'is-hide-info': _ctx.hideInfo }]])
  }, [
    (!_ctx.file.deleted)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          id: "videoPath",
          "data-fancybox": _ctx.useSharedFancybox ? _ctx.fancyboxData : null,
          "video-data-fancybox": _ctx.useSharedFancybox ? null : _ctx.fancyboxData,
          "data-caption": _ctx.file.name,
          "data-file-metadata-id": _ctx.file.id,
          href: _ctx.videoPath,
          "data-type": _ctx.useSharedFancybox ? 'html5video' : 'video',
          class: "video-attachment__link"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("video", {
                class: "video-attachment__video",
                src: _ctx.videoPath
              }, null, 8, _hoisted_4)
            ]),
            (!_ctx.hideInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_BaseSubHeading, {
                    color: "monochrome-07",
                    weight: "400",
                    size: "large",
                    class: "video-attachment__title"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_BaseSubHeading, {
                    size: "extra-small",
                    weight: "500",
                    color: "monochrome-05",
                    darkColor: "monochrome-04",
                    class: "video-attachment__size"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatBytes(_ctx.file.size.toString())), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.hideInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_icon, {
                    data: _imports_0,
                    width: "var(--icon-24)",
                    height: "var(--icon-24)",
                    color: "var(--monochrome05to04)"
                  })
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_icon, {
                        data: _imports_0,
                        width: "var(--icon-24)",
                        height: "var(--icon-24)",
                        color: "var(--monochrome05to04)"
                      })
                    ]),
                    _createVNode(_component_BaseSubHeading, {
                      weight: "400",
                      class: "video-attachment_deleted__name",
                      size: "medium"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_BaseSubHeading, {
                    weight: "500",
                    size: "extra-small",
                    class: "video-attachment_deleted__info",
                    color: "monochrome-05",
                    darkColor: "monochrome-04"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Deleted by " + _toDisplayString(_ctx.file.deletedBy?.fullName), 1)
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          (!_ctx.hideInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_BaseSubHeading, {
                  color: "monochrome-07",
                  weight: "400",
                  size: "large",
                  class: "video-attachment__title"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_BaseSubHeading, {
                  size: "extra-small",
                  weight: "500",
                  color: "monochrome-05",
                  darkColor: "monochrome-04",
                  class: "video-attachment_deleted__initiator"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Deleted by " + _toDisplayString(_ctx.file.deletedBy?.fullName), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}